import { Address } from './address.model';
import { Document } from './document.model';
import { Education } from './education.model';
import { Rating } from './rating.model';
import { Specialty } from './specialty.model';
import { Testimonial } from './testimonial.model';
import { Therapy } from './therapy.model';
import { User } from './user.model';

export class Practitioner extends User {
  public approach: string;
  public bio: string;
  public conditions: string[];
  public documents: Document[];
  public education: Education[];
  public firstName: string;
  public gender: string;
  public healthCategory: string[];
  public id: string;
  public insuranceType: string[];
  public isApproved: boolean;
  public languages: string[];
  public lastName: string;
  public licenses: string[];
  public location: Address;
  public offersVirtual: boolean;
  public phoneNumber: string;
  public profileImage: string;
  public rating: Rating;
  public salutation: string;
  public specialties: Specialty[];
  public status: string;
  public testimonials: Testimonial[];
  public title: string;

  public approvalDate: number;
  public createdAt: number;
  public updatedAt: number;

  constructor(
    approach: string,
    bio: string,
    conditions: string[],
    documents: Document[],
    education: Education[],
    email: string,
    firstName: string,
    gender: string,
    healthCategory: string[],
    insuranceType: string[],
    isApproved: boolean,
    languages: string[],
    lastName: string,
    licenses: string[],
    location: Address,
    offersVirtual: boolean,
    phoneNumber: string,
    profileImage: string,
    rating: Rating,
    salutation: string,
    specialties: Specialty[],
    status: string,
    title: string,
    approvalDate: number,
    createdAt: number,
    updatedAt: number,
    id?: string,
    testimonials?: Testimonial[]
  ) {
    super(email, id);

    this.approach = approach;
    this.bio = bio;
    this.conditions = conditions;
    this.documents = documents;
    this.education = education;
    this.email = email;
    this.firstName = firstName;
    this.gender = gender;
    this.healthCategory = healthCategory;
    this.insuranceType = insuranceType;
    this.isApproved = isApproved;
    this.languages = languages;
    this.lastName = lastName;
    this.licenses = licenses;
    this.location = location;
    this.offersVirtual = offersVirtual;
    this.phoneNumber = phoneNumber;
    this.profileImage = profileImage;
    this.rating = rating;
    this.salutation = salutation;
    this.specialties = specialties;
    this.status = status;
    this.title = title;
    this.approvalDate = approvalDate;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.id = id;
    this.testimonials = testimonials;
  }

  public getFullName(): string {
    return (this.salutation ? this.salutation + ' ' : '') + this.firstName + ' ' + this.lastName;
  }

  public getInsurance(): string {
    if (!this.insuranceType) { return null; }
    if (this.insuranceType.length > 1) {
      return 'All';
    } else {
      return this.insuranceType[0];
    }
  }

  public getHealthCategory(): string {
    if (this.healthCategory.length > 1) {
      return 'Both';
    } else {
      return this.healthCategory[0];
    }
  }

  public getStartingCost(): number {
    var startingCost: number = -1;
    this.specialties.forEach((specialty: Specialty) => {
      specialty.therapies.forEach((therapy: Therapy) => {
        if (startingCost < 0 || therapy.cost < startingCost) {
          startingCost = therapy.cost;
        }
      });
    });

    return startingCost;
  }

  public getLanguages(): string {
    var languages: string = this.languages.toString();
    if (languages.length <= 1) {
      return languages;
    }
    return languages.replace(/,/g , ', ');
  }

  public mapToFirestore(): any {
    return {
      approach: this.approach,
      bio: this.bio,
      conditions: this.conditions,
      documents: Document.mapArrayToFirestore(this.documents),
      education: Education.mapArrayToFirestore(this.education),
      email: this.email,
      firstName: this.firstName,
      gender: this.gender,
      healthCategory: this.healthCategory,
      insuranceType: this.insuranceType,
      isApproved: this.isApproved,
      languages: this.languages,
      lastName: this.lastName,
      licenses: this.licenses,
      location: this.location.mapToFirestore(),
      offersVirtual: this.offersVirtual,
      phoneNumber:  this.phoneNumber,
      profileImage: this.profileImage,
      rating: this.rating,
      salutation: this.salutation,
      specialties: Specialty.mapArrayToFirestore(this.specialties),
      status: this.status,
      title: this.title,
      approvalDate: this.approvalDate,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }

  static mapFromFirestore(practitioner: any, id: string) {
    return new Practitioner(
      practitioner.approach,
      practitioner.bio,
      practitioner.conditions,
      Document.mapArrayFromFirestore(practitioner.documents),
      Education.mapArrayFromFirestore(practitioner.education),
      practitioner.email,
      practitioner.firstName,
      practitioner.gender,
      practitioner.healthCategory,
      practitioner.insuranceType,
      practitioner.isApproved,
      practitioner.languages,
      practitioner.lastName,
      practitioner.licenses,
      Address.mapFromFirestore(practitioner.location),
      practitioner.offersVirtual,
      practitioner.phoneNumber,
      practitioner.profileImage,
      Rating.mapFromFirestore(practitioner.rating),
      practitioner.salutation,
      Specialty.mapArrayFromFirestore(practitioner.specialties),
      practitioner.status,
      practitioner.title,
      practitioner.approvalDate,
      practitioner.createdAt,
      practitioner.updatedAt,
      id
    );
  }
}
